import React, { useMemo } from 'react';
import SplitButton from "../Common/SplitButton";
import axios from "axios";
import { useEffect, useState } from "react";
import config from "../../config";
import { useSelector } from "react-redux";
import loadingImg from "../../assets/loading.gif"

const OrderManagement = () => {

    const companyId = useSelector((state) => state.user.companyId);
    const [list, setList] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [action, setAction] = useState(0);


    useEffect(() => {

        setList([]);
        getOpenBatchIds(companyId);

    }, [])

    const getOpenBatchIds = async (companyId) => {
        try {
            //const res = await axios.get(config.BL_API_URL + "/client/v1/getUnprocessedBatches", { params: { companyId } });
            const res = await axios.get(`${config.BL_API_URL}/client/v1/getUnprocessedBatches/${companyId}`);

            if (res.status === 200) {
                setList(res.data);
            }

        } catch (err) {
            console.log(err)
        }

    }


    const applyAction = async () => {
        console.log("Action " + action);
        
        console.log("Action ..." + action)
        try {
            if (action === 0 || action === undefined) {
                return;
            }

            let actionUrl;
            if (Number(action) === 1) {
                actionUrl = "applyAction"

            } else if (Number(action) === 2) {

                actionUrl = "changeToError"

            } else if (Number(action) === 4) {
                actionUrl = "changeToOpen"

            } else if (Number(action) === 3) {
                actionUrl = "changeToOnHold"

            }
            console.log("Value ... " + actionUrl)
            if (actionUrl !== null && actionUrl !== "" && actionUrl !== undefined) {
                setIsLoading(true);

                const res = await axios.post(config.BL_API_URL + "/client/v1/" + actionUrl, list);

                if (res.status === 200) {
                    getOpenBatchIds(companyId);
                }                
            }
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
            console.log(err)
        }
    }

    const onSelectionChange = (e) => {
        if (e.target.value === "-") {
            return;
        }
        setAction(e.target.value);
    }

    const handleRefresh = () => {
        setIsAllChecked(false);
        getOpenBatchIds(companyId);
    };

    const handleCheckAll = (event) => {
        const newItems = list.map(item => ({
            ...item,
            isChecked: event.target.checked,
        }));
        setList(newItems);
        setIsAllChecked(event.target.checked);
    };

    const handleCheck = (id) => {

        const newItems = list.map(item => {
            if (item.batchId === id) {
                return { ...item, isChecked: !item.isChecked };
            }
            return item;
        });
        setList(newItems);

        // Update isAllChecked based on individual checks
        setIsAllChecked(newItems.every(item => item.isChecked));
    };

    const getBatchPrefix = (batchId) => {
        if (!batchId) {
            return "";
        }

        return String(batchId).split('_')[0].trim();
    };

    const getMessageValue = (message) => {
        return String(message || '').trim();
    };

    const getMessageDisplayValue = (prefix, message) => {
        const normalizedMessage = getMessageValue(message);

        if (!normalizedMessage) {
            return '';
        }

        const escapedPrefix = prefix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const prefixRegex = new RegExp(`^${escapedPrefix}[\\s_:-]*`, 'i');
        const trimmedMessage = normalizedMessage.replace(prefixRegex, '').trim();

        return trimmedMessage || normalizedMessage;
    };

    const getSideValue = (item) => {
        const rawSide = String(item?.orderType || item?.action || '').trim().toUpperCase();

        if (rawSide === 'B' || rawSide === 'BUY') {
            return 'Buy';
        }

        if (rawSide === 'S' || rawSide === 'SELL') {
            return 'Sell';
        }

        return String(item?.orderType || item?.action || '').trim();
    };

    const selectRows = (matcher) => {
        const newItems = list.map(item => ({
            ...item,
            isChecked: matcher(item),
        }));

        setList(newItems);
        setIsAllChecked(newItems.length > 0 && newItems.every(item => item.isChecked));
    };

    const selectByBatchPrefix = (prefix) => {
        selectRows((item) => getBatchPrefix(item.batchId) === prefix);
    };

    const selectByBatchPrefixAndMessage = (prefix, message) => {
        selectRows((item) => {
            const itemPrefix = getBatchPrefix(item.batchId);
            const itemMessage = getMessageValue(item.status);

            return itemPrefix === prefix && itemMessage === message;
        });
    };

    const selectByBatchPrefixMessageAndSide = (prefix, message, side) => {
        selectRows((item) => {
            const itemPrefix = getBatchPrefix(item.batchId);
            const itemMessage = getMessageValue(item.status);
            const itemSide = getSideValue(item);

            return itemPrefix === prefix && itemMessage === message && itemSide === side;
        });
    };

    const batchSelectionOptions = useMemo(() => {
        const groupedOptions = new Map();

        list.forEach((item) => {
            const prefix = getBatchPrefix(item.batchId);
            const message = getMessageValue(item.status);
            const side = getSideValue(item);

            if (!prefix) {
                return;
            }

            if (!groupedOptions.has(prefix)) {
                groupedOptions.set(prefix, new Map());
            }

            if (message && side) {
                if (!groupedOptions.get(prefix).has(message)) {
                    groupedOptions.get(prefix).set(message, new Set());
                }

                groupedOptions.get(prefix).get(message).add(side);
            } else if (message) {
                if (!groupedOptions.get(prefix).has(message)) {
                    groupedOptions.get(prefix).set(message, new Set());
                }
            }
        });

        return Array.from(groupedOptions.entries()).map(([prefix, messageMap]) => ({
            label: prefix,
            onClick: () => selectByBatchPrefix(prefix),
            children: Array.from(messageMap.entries()).flatMap(([message, sideSet]) => {
                const displayMessage = getMessageDisplayValue(prefix, message);
                const sides = Array.from(sideSet);

                if (sides.length === 0) {
                    return [{
                        label: `${prefix} - ${displayMessage}`,
                        onClick: () => selectByBatchPrefixAndMessage(prefix, message),
                    }];
                }

                return sides.map((side) => ({
                    label: `${prefix} - ${displayMessage} - ${side}`,
                    onClick: () => selectByBatchPrefixMessageAndSide(prefix, message, side),
                }));
            }),
        }));
    }, [list]);

    return (
        <div>
            <div className="my-14 md:px-14 p-2 max-w-screen-xl mx-auto ">
                <div className="flex flex-col">
                    <div className="border rounded-lg divide-y divide-gray-200">
                        <div className='col-span-2'>
                            <div className=" col-span-1">
                                <div className='row-span-1 flex justify-center content-center items-center gap-x-2 py-2 px-4'>
                                    <div className='col-span-1'>
                                        <label className='px-6 py-2 text-left font-medium' >Action</label>
                                    </div>
                                    <div className='col-span-1'>
                                        <select onChange={onSelectionChange} id="batchId" name="batchId" defaultValue="-" className='border border-gray-300 rounded-md' >
                                            <option value="-">Select</option>
                                            <option value="1">Remove</option>
                                            <option value="2">Move to Error</option>
                                            <option value="3">Move to OnHold</option>
                                            <option value="4">Move to Open</option>
                                        </select>
                                    </div>
                                    <div className='col-span-1'>
                                        <button onClick={e => applyAction()}
                                            className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center">
                                            {isLoading &&
                                                <img src={loadingImg} alt="Icon" className="w-6 text-left justify-start items-right" />
                                            }
                                            {!isLoading &&
                                                <svg className="fill-current w-6 h-6 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><polyline fill="none" points="3.7 14.3 9.6 19 20.3 5" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" /></svg>
                                            }
                                            <span>Apply</span>
                                        </button>
                                    </div>
                                    <div className='col-span-1'>
                                        <button
                                            type="button"
                                            onClick={handleRefresh}
                                            className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center"
                                        >
                                            <svg className="fill-current w-5 h-5 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                <path d="M17.65 6.35A7.95 7.95 0 0 0 12 4V1L7 6l5 5V7a5 5 0 1 1-4.9 6h-2.02A7 7 0 1 0 17.65 6.35z" />
                                            </svg>
                                            <span>Refresh</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="max-h-96 overflow-y-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-200 sticky top-0 z-10">
                                    <tr>
                                        <th scope="col" className="px-6 py-2 text-left text-xs font-medium text-gray-500 bg-gray-200 uppercase">#</th>
                                        <th scope="col" className="px-6 py-2 text-left text-xs font-medium text-gray-500 bg-gray-200 uppercase">
                                            <SplitButton
                                                mainLabel="All"
                                                onMainClick={() => handleCheckAll({ target: { checked: !isAllChecked } })}
                                                options={batchSelectionOptions}
                                            />
                                        </th>
                                        <th scope="col" className="px-6 py-2 text-left text-xs font-medium text-gray-500 bg-gray-200 uppercase">Batch Id</th>
                                        <th scope="col" className="px-6 py-2 text-left text-xs font-medium text-gray-500 bg-gray-200 uppercase">Batch Order Type</th>
                                        <th scope="col" className="px-6 py-2 text-start text-xs font-medium text-gray-500 bg-gray-200 uppercase">Action</th>
                                        <th scope="col" className="px-6 py-2 text-start text-xs font-medium text-gray-500 bg-gray-200 uppercase">Client Code</th>
                                        <th scope="col" className="px-6 py-2 text-start text-xs font-medium text-gray-500 bg-gray-200 uppercase">Message</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list &&
                                        list.map((item, index) => (
                                            <tr key={index} className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-100'} hover:bg-gray-300`}>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800">{index + 1}</td>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800">
                                                    <input type='checkbox' id={item.batchId} checked={!!item.isChecked}
                                                        onChange={() => handleCheck(item.batchId)} />
                                                </td>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800">{item.batchId}</td>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800">{item.orderType}</td>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800">{item.action}</td>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800">{item.clientCode}</td>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800">{item.status}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OrderManagement;